"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadstromTextCodec = void 0;
class CadstromTextCodec {
    decode(raw) {
        let text = '';
        const transforms = [];
        let index = 0;
        const prefix = '\\overline{';
        while (index < raw.length) {
            if (raw.substring(index, index + prefix.length) === prefix) {
                const close = raw.indexOf('}', index + prefix.length);
                if (close > index + prefix.length) {
                    const from = text.length;
                    text += raw.substring(index + prefix.length, close);
                    transforms.push({ type: 'bar', from, to: text.length });
                    index = close + 1;
                    continue;
                }
            }
            text += raw[index];
            index++;
        }
        return { text, transforms };
    }
}
exports.CadstromTextCodec = CadstromTextCodec;
//# sourceMappingURL=CadstromTextCodec.js.map